export default "__VITE_ASSET__DKqVZGOM__"